module.exports = __webpack_public_path__ + "static/img/Important.17d9d36b.png";